import { useEffect, useCallback } from 'react';

/**
 * A hook to manage focus-related accessibility styles on the document body.
 */
export const useFocusStyles = () => {
  const handleKeyPress = useCallback((event) => {
    // 9 is the keycode for the Tab key
    if (event.keyCode === 9) {
      document.body.classList.remove('disable-focus-styles');
    }
  }, []);

  useEffect(() => {
    document.body.classList.add('disable-focus-styles');
    window.addEventListener('keydown', handleKeyPress);

    return () => {
      document.body.classList.remove('disable-focus-styles');
      window.removeEventListener('keydown', handleKeyPress, false);
    };
  }, [handleKeyPress]);
};
